import React, { useState, useEffect, useCallback } from 'react';
import debounce from 'lodash.debounce';
import * as mainService from '@app/services/mainService';
const DaohuuLayoutComponent = ({ currentSuggestion , showClose ,onChange}) => {


  return (
    <div className="form-group">
          <div className="form-control d-flex align-items-center">
            <img
              src={currentSuggestion.image}
              alt={currentSuggestion.ten}
              className="img-thumbnail mr-2"
              width="40"
            />
            <span>{currentSuggestion.ten + ' ' + currentSuggestion.dien_thoai}</span>
           {
            showClose && ( <button 
              type="button" 
              className="close ml-auto" 
              aria-label="Close" 
              onClick={() => onChange(null)}
            >
              <span aria-hidden="true">&times;</span>
            </button>)
           }
          </div>
        </div>
            )
 
};

export default DaohuuLayoutComponent;





